import ExamPage from './Exam'
export default ExamPage
